import {boundMethod} from "autobind-decorator";
import React from "react";

import {BootstrapColors} from "./models";

interface IDropdownButtonProps {
    type: BootstrapColors;
    idSuffix: string;
    menu(): JSX.Element | null;

    classNameButton?: string; // no btn btn-... with this string
    disabled?: boolean;
    isButtonGroup?: boolean;
    standAloneButton?: boolean;
    style?: React.CSSProperties;
    title?: string;
}

interface IDropdownButtonState {
    left: boolean;
}

class DropdownButton extends React.PureComponent<
    IDropdownButtonProps,
    IDropdownButtonState
> {
    public readonly state: IDropdownButtonState = {
        left: false,
    };

    private readonly ref = React.createRef<HTMLButtonElement>();

    public componentDidMount() {
        this.setLayout();
    }

    @boundMethod
    public setLayout() {
        const ref = this.ref.current;
        if (!ref) {
            return;
        }

        const rect = ref.getBoundingClientRect();
        const middle = rect.left + rect.width / 2;
        const left = middle > document.body.clientWidth / 2;
        this.setState({left});
    }

    public render() {
        const {isButtonGroup} = this.props;

        if (isButtonGroup) {
            return (
                <div className="dropdown btn-group">{this.renderButton()}</div>
            );
        }

        return this.renderButton();
    }

    private renderButton() {
        const {
            children,
            classNameButton,
            disabled,
            idSuffix,
            standAloneButton,
            style,
            title,
            type,
            menu,
        } = this.props;
        const {left} = this.state;
        const id = "dropdown-" + idSuffix;

        let className = `btn btn-${type}`;
        if (!standAloneButton) {
            className += " dropdown-toggle";
        }

        if (classNameButton) {
            className += ` ${classNameButton}`;
        }

        return (
            <React.Fragment>
                <button
                    ref={this.ref}
                    type="button"
                    id={id}
                    className={className}
                    aria-expanded="false"
                    aria-haspopup="true"
                    data-toggle="dropdown"
                    disabled={disabled}
                    style={style}
                    title={title}
                    onMouseEnter={this.setLayout}
                >
                    {children}
                </button>
                <div
                    className={
                        "dropdown-menu dropdown-menu-" +
                        (left ? "right" : "left")
                    }
                    aria-labelledby={id}
                >
                    {menu()}
                </div>
            </React.Fragment>
        );
    }
}

export default DropdownButton;
